import { styled } from 'styletron-react';

export const PriceTag = styled('p', {
  color: `#007c94!important`,
  lineHeight: '2rem'
});
